"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const firebaseIsPathLinkValid_1 = __importDefault(require("./firebaseIsPathLinkValid"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const firebaseIsPathValid = (path) => {
    try {
        if (path.startsWith('/')) {
            throw new Error('Path must be an string without starting slash');
        }
        if (path.endsWith('/')) {
            throw new Error('Path must be an string without ending slash');
        }
        const pathParts = path.split('/');
        if (pathParts.length === 0) {
            throw new Error('Path must to be an string with at least one part');
        }
        pathParts.forEach((pathPart) => {
            const validLinkMessageError = (0, firebaseIsPathLinkValid_1.default)(pathPart);
            if (validLinkMessageError) {
                throw new Error(validLinkMessageError);
            }
        });
    }
    catch (error) {
        return `${(0, getValueByPathFromUnknown_1.default)(error, ['message']) || error}`;
    }
    return undefined;
};
exports.default = firebaseIsPathValid;
